/* eslint-disable no-prototype-builtins */
/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

/**
 * This is a helper method that turn the colors dictionary into dropdown options
 * @param colors
 */
export const getAllColorsAsDropdownOptions = (colors: any) => {
    const options = [] as any;

    for (const key in colors) {
        if (!colors?.hasOwnProperty(key)) {
            continue;
        }

        for (const subKey in colors[key]) {
            if (!colors[key]?.hasOwnProperty(subKey)) {
                continue;
            }

            if (subKey.toLowerCase().indexOf("contrast") === -1) {
                options.push({ displayName: `${key}.${subKey}`, value: `${key}.${subKey}` });
            }
        }
    }

    return options;
};

export default getAllColorsAsDropdownOptions;
